import React from "react";

const MOBILE_NUMBER_EMAIL = React.lazy(() => import("./signup"));
const RESUME = React.lazy(() => import("./upload-resume"));
const WORK_AUTH = React.lazy(() => import("./authorization"));
const CURRENT_LOCATION = React.lazy(() => import("./current-location"));
const CURRENT_DESIGNATION_CURRENT_COMPANY = React.lazy(
  () => import("./designation-and-company"),
);
const TRIUMPH_FIELDS = React.lazy(() => import("./disability"));
const EDUCATION_TYPE = React.lazy(() => import("./education-type"));
const START_DATE_CURRENTLY_WORKING_HERE_CHECKBOX = React.lazy(
  () => import("./employment-start"),
);
const END_DATE = React.lazy(() => import("./employment-end"));
const FULL_NAME = React.lazy(() => import("./full-name"));
const SPECIALISATION = React.lazy(() => import("./specialization"));
const TOTAL_EXPERIENCE = React.lazy(() => import("./total-exp"));
const UNIVERSITY = React.lazy(() => import("./university"));
const LINKEDIN = React.lazy(() => import("./linkedin"));
const WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX = React.lazy(
  () => import("./looking-for"),
);
const NATIONALITY = React.lazy(() => import("./nationality"));
const NOTICE_PERIOD = React.lazy(() => import("./notice-period"));
const PREFERRED_LOCATION = React.lazy(() => import("./preferred-location"));
const PREFERRED_JOB_TITLE = React.lazy(() => import("./preferred-role"));
const HIGHEST_QUALIFICATION = React.lazy(() => import("./qualification"));
const CURRENT_SALARY_HIDE_SALARY_CHECKBOX = React.lazy(
  () => import("./salary-range"),
);
const SKILLS = React.lazy(() => import("./skills"));
const GENDER = React.lazy(() => import("./gender"));
const YEAR_OF_GRADUATION = React.lazy(() => import("./graduation-year"));
const QUALIFICATION_BOARD = React.lazy(() => import("./board"));
const QUALIFICATION_MEDIUM = React.lazy(() => import("./medium"));
const SUCCESS = React.lazy(() => import("./success"));
const LAST_WORKING_DAY = React.lazy(() => import("./last-working-day"));
const MOBILE_OTP = React.lazy(
  () => import("./verification/mobile-verification"),
);
const EMAIL_OTP = React.lazy(() => import("./verification/email-verification"));
const INDUSTRY = React.lazy(() => import("./industry"));

export const regScreen = [
  "MOBILE_NUMBER_EMAIL",
  "MOBILE_OTP",
  "EMAIL_OTP",
  "RESUME",
  "FULL_NAME",
  "TOTAL_EXPERIENCE",
  "CURRENT_LOCATION",
  "NATIONALITY",
  "WORK_AUTH",
  "CURRENT_DESIGNATION_CURRENT_COMPANY",
  "START_DATE_CURRENTLY_WORKING_HERE_CHECKBOX",
  "END_DATE",
  "NOTICE_PERIOD",
  "LAST_WORKING_DAY",
  "CURRENT_SALARY_HIDE_SALARY_CHECKBOX",
  "SKILLS",
  "LINKEDIN",
  "INDUSTRY",
  "GENDER",
  "TRIUMPH_FIELDS",
  "HIGHEST_QUALIFICATION",
  "SPECIALISATION",
  "UNIVERSITY",
  "QUALIFICATION_BOARD",
  "QUALIFICATION_MEDIUM",
  "YEAR_OF_GRADUATION",
  "EDUCATION_TYPE",
  "WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX",
  "PREFERRED_JOB_TITLE",
  "PREFERRED_LOCATION",
  "SUCCESS",
] as const satisfies readonly (keyof typeof regMap)[];

export type RegMapKeyType = (typeof regScreen)[number];

export const regMap: { [key: string]: React.ComponentType } = {
  MOBILE_NUMBER_EMAIL,
  MOBILE_OTP,
  EMAIL_OTP,
  RESUME,
  FULL_NAME,
  TOTAL_EXPERIENCE,
  CURRENT_LOCATION,
  NATIONALITY,
  WORK_AUTH,
  CURRENT_DESIGNATION_CURRENT_COMPANY,
  START_DATE_CURRENTLY_WORKING_HERE_CHECKBOX,
  END_DATE,
  NOTICE_PERIOD,
  LAST_WORKING_DAY,
  CURRENT_SALARY_HIDE_SALARY_CHECKBOX,
  SKILLS,
  LINKEDIN,
  INDUSTRY,
  GENDER,
  TRIUMPH_FIELDS,
  HIGHEST_QUALIFICATION,
  SPECIALISATION,
  UNIVERSITY,
  QUALIFICATION_BOARD,
  QUALIFICATION_MEDIUM,
  YEAR_OF_GRADUATION,
  EDUCATION_TYPE,
  WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX,
  PREFERRED_JOB_TITLE,
  PREFERRED_LOCATION,
  SUCCESS,
};

export const BASIC_FLOW_FOR_ALL_USER: Partial<RegMapKeyType>[] = [
  "MOBILE_NUMBER_EMAIL",
  "MOBILE_OTP",
  "EMAIL_OTP",
  "RESUME",
  "FULL_NAME",
  "TOTAL_EXPERIENCE",
  "CURRENT_LOCATION",
  "NATIONALITY",
  "WORK_AUTH",
];

export const EXPERIENCED_USER_SCREEN: Partial<RegMapKeyType>[] = [
  ...BASIC_FLOW_FOR_ALL_USER,
  "CURRENT_DESIGNATION_CURRENT_COMPANY",
  "START_DATE_CURRENTLY_WORKING_HERE_CHECKBOX",
  "END_DATE",
  "SKILLS",
  "CURRENT_SALARY_HIDE_SALARY_CHECKBOX",
  "NOTICE_PERIOD",
  "LAST_WORKING_DAY",
  "LINKEDIN",
  "INDUSTRY",
  "GENDER",
  "TRIUMPH_FIELDS",
  "HIGHEST_QUALIFICATION",
  "SPECIALISATION",
  "UNIVERSITY",
  "QUALIFICATION_BOARD",
  "QUALIFICATION_MEDIUM",
  "YEAR_OF_GRADUATION",
  "EDUCATION_TYPE",
  "WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX",
  "PREFERRED_JOB_TITLE",
  "PREFERRED_LOCATION",
  "SUCCESS",
];

export const FRESHER_USER_SCREEN: Partial<RegMapKeyType>[] = [
  ...BASIC_FLOW_FOR_ALL_USER,
  "PREFERRED_JOB_TITLE",
  "HIGHEST_QUALIFICATION",
  "SPECIALISATION",
  "UNIVERSITY",
  "QUALIFICATION_BOARD",
  "QUALIFICATION_MEDIUM",
  "YEAR_OF_GRADUATION",
  "EDUCATION_TYPE",
  "SKILLS",
  "LINKEDIN",
  "GENDER",
  "TRIUMPH_FIELDS",
  "WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX",
  "PREFERRED_LOCATION",
  "SUCCESS",
];

export const EXPERIENCED_SKIPABLE_SCREEN: Partial<RegMapKeyType>[] = [
  "RESUME",
  "LINKEDIN",
  "INDUSTRY",
  "GENDER",
  "TRIUMPH_FIELDS",
  "HIGHEST_QUALIFICATION",
  "QUALIFICATION_BOARD",
  "QUALIFICATION_MEDIUM",
  "SPECIALISATION",
  "UNIVERSITY",
  "YEAR_OF_GRADUATION",
  "EDUCATION_TYPE",
  "PREFERRED_JOB_TITLE",
  "PREFERRED_LOCATION",
];

export const FRESHER_SKIPABLE_SCREEN: Partial<RegMapKeyType>[] = [
  "RESUME",
  "LINKEDIN",
  "GENDER",
  "TRIUMPH_FIELDS",
  "PREFERRED_LOCATION",
];
